module.exports = __webpack_public_path__ + "img/z01.826aafbb.png";